/**
 * @file 顶部栏组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';

export default class TopBar extends Component {
    static template = `
        <div class="top-bar-wrap">
            <div class="bar common-padding">
                <div class="icon" on-click="goHome" s-if="false"></div>
                <span class="text">{{title}}</span>
            </div>
        </div>
    `;
    initData() {
        return {
            title: '古物潮玩'
        };
    }
    // 小房子图标点击去小程序web化首页
    goHome() {
        location.href = 'https://szhdy8.smartapps.cn/pages/feed/index';
    }
}
